<template>
  <messenger-chat-message-layout
    direction="outcoming"
    :message-time="message.messageTime"
    :status="message.status"
  >
    <span
      v-if="messageHtml"
      v-safe-html="messageHtml"
      class="break-word"
    />

    <messenger-chat-message-info-compensator
      v-if="!message.attachments.length"
      :message-time="message.messageTime"
      :status="message.status"
    />

    <messenger-chat-message-attachments
      v-if="message.attachments.length"
      class="message-attachments"
      :attachments="message.attachments"
    >
      <template v-slot:message-info-compensator>
        <messenger-chat-message-info-compensator
          :message-time="message.messageTime"
          :status="message.status"
        />
      </template>
    </messenger-chat-message-attachments>
  </messenger-chat-message-layout>
</template>

<script lang="ts" setup>
import MessengerChatMessageLayout from '@widgets/messenger/components/messages/MessengerChatMessageLayout.vue'
import type { MessengerSentMessageListItem } from '@widgets/messenger/types/chat/message'
import { useWidgetChatMessageText } from '@widgets/messenger/compositions/useWidgetChatMessageText'
import MessengerChatMessageInfoCompensator from '@widgets/messenger/components/messages/MessengerChatMessageInfoCompensator.vue'
import MessengerChatMessageAttachments from '@widgets/messenger/components/messages/MessengerChatMessageAttachments.vue'

const props = defineProps<{
  message: MessengerSentMessageListItem
}>()

const { messageHtml } = useWidgetChatMessageText(() => props.message.text)
</script>

<style lang="scss" scoped>
.message-attachments:not(:first-child) {
  margin-top: 6px;
}
</style>
